module.exports = __webpack_public_path__ + "res/Roboto-BoldCondensed-webfont.ttf?ab6055feabbd07b6504658934a71fe4c";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldCondensed-webfont.ttf
// module id = 49
// module chunks = 0